<template>
  <div style="position: relative;overflow-y: auto;height:calc(100vh - 70px)">
    <div style="width: 1200px;margin: 0 auto;padding-bottom: 40px">
     <!-- <p style="font-size: 18px;line-height: 35px;margin: 30px auto 10px;text-align: right">主页 > 通知公告</p>-->
      <img src="../../assets/images/home/01notice.png" alt="" class="titleImg" style="margin: 50px auto 30px">
      <div class="" style="position: relative">
        <div class="" style="text-align: left;">
          <dl class="news_dl_side" style="margin-bottom: 0px!important">
            <dd v-for="datatype in this.newsNotice.slice((currentPage-1)*PageSize,currentPage*PageSize)">
              <span class="spanNumber">{{datatype.index}}</span>
              <span class="spanTitle" :title="datatype.title" @click="hotInform(datatype.id)">{{datatype.title}}</span>
              <span class="news_date">{{datatype.issueTime}}</span>
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="tabListPage" style="position: fixed;margin: 0 auto;bottom: 0;text-align: center;left: 0;right: 0;height: 45px;background-color: #fff">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                      :page-size="PageSize" layout="total, prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";
  import {dateStr2Times} from "../../util/TimeTransition";

  export default {
    name: "ViewMore",
    computed: mapState([
      'newsNotice'
    ]),
    data() {
      return {
        index: 1, // 总数据
        tableData: [], // 默认显示第几页
        currentPage: 1, // 总条数，根据接口获取数据长度(注意：这里不能为空)
        totalCount: 0, // 个数选择器（可修改）
        PageSize: 15,
      }
    },
    methods: {
      /**
       * 每页显示的条数
       * @param val
       */
      handleSizeChange(val) {
        this.PageSize = val  // 改变每页显示的条数
        this.currentPage = 1  // 注意：在改变每页显示的条数时，要将页码显示到第一页
      },

      /**
       *  显示第几页
       * @param val
       */
      handleCurrentChange(val) {
        this.currentPage = val// 改变默认的页数
      },

      /**
       * 点击热点新闻
       */
      hotInform(id) {
        let routeUrl = this.$router.resolve({
          path: '/hot_inform?id=' + id,
        });
        window.open(routeUrl.href, '_blank');
      },
    },

    watch: {
      newsNotice: function () {
        /*let notice = this.newsNotice
        for (let i = 0; i < notice.length; i++) {
          notice[i].index = i+2
          notice[i].issueTime = dateStr2Times(notice[i].issueTime)
        }*/
        let notice = this.newsNotice
        this.totalCount = notice.length
        for (let i = 0; i < notice.length; i++) {
          notice[i].index = i + 1
          notice[i].issueTime = dateStr2Times(notice[i].issueTime)
        }
      }
    },

    created() {
      let notice = this.newsNotice
      this.totalCount = notice.length
      for (let i = 0; i < notice.length; i++) {
        notice[i].index = i + 1
        notice[i].issueTime = dateStr2Times(notice[i].issueTime)
      }
    }
  }
</script>

<style scoped>
  .spanTitle{
    cursor: pointer;
    display: inline-block;
    /*width: 250px;*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/page/Layout/ViewMore.vue